import styled from "styled-components";

export const MarkerMapStyle = styled.div`
    width: 100%;
    height: 300px;
`;
